<template>
<div class="chapter">
<div class="inner_page">
<h1 class="subchapter">Works Cited</h1>
<p class="hanging">Brown, Alan. <em>Ghost Hunters of the South.</em> Jackson: University Press of Mississippi, 2006.</p>
<p class="hanging">———. <em>Haunted Kentucky: Ghosts and Strange Phenomena of the Bluegrass State.</em> Mechanicsburg, Pa.: Stackpole Books, 2009.</p>
<p class="hanging">———. <em>Shadows and Cypress: Southern Ghost Stories.</em> Jackson: University Press of Mississippi, 2000.</p>
<p class="hanging">McNeil, W. K. <em>Ghost Stories from the American South.</em> New York: Dell, 1985.</p>
<p class="hanging">Montell, William Lynwood. <em>Ghosts across Kentucky.</em> Lexington: University Press of Kentucky, 2000.</p>
<p class="hanging">———. <em>Ghosts along the Cumberland: Deathlore in the Kentucky Foothills.</em> Knoxville: University of Tennessee Press, 1975.</p>
<p class="hanging">———. <em>Haunted Houses and Family Ghosts of Kentucky.</em> Lexington: University Press of Kentucky, 2001.</p>
<p class="hanging">Walker, Barbara. <em>Out of the Ordinary: Folklore and the Supernatural.</em> Logan: Utah State University Press, 1995.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780813173894_epub_wc_r1.vue?606dcd40